import { HR_BANKS } from "./consts";

export function getBankFromHrIban(iban: string) {
  if (!iban || iban.length < 11) return null;

  const clean = iban.replace(/\s+/g, '').toUpperCase();
  const vbdi = clean.substring(4, 11);

  return HR_BANKS.find(b => b.vbdi === vbdi) || null;
}

export function isHrIbanValid(iban: string) {
  if (!iban) return false;

  const clean = iban.replace(/\s+/g, '').toUpperCase();
  if (clean.length !== 21) return false;
  if (!clean.startsWith('HR')) return false;

  const banka = getBankFromHrIban(clean);
  if (!banka) return false;

  let modString = clean.substring(4) + clean.substring(0, 4);
  modString = modString.replace(/H/g, '17').replace(/R/g, '27');

  if (!/^\d+$/.test(modString)) return false;

  let remainder = 0;
  for (const digit of modString) {
    remainder = (remainder * 10 + Number(digit)) % 97;
  }

  return remainder === 1;
}
